import { useState, type FormEvent } from 'react'
import { ApiError } from '../api/client'
import { newUuid } from '../offline/uuid'
import { useCreateVehicle } from './useCustomers'
import { EMPTY_VEHICLE_FIELDS, VehicleDetailFields, vehicleFieldsToBody, type VehicleFieldValues } from './VehicleFields'

/** Fahrzeug zu einem Kunden anlegen (Kennzeichen Pflicht, Fahrzeugschein-Stammdaten optional). Idempotent über client_uuid. */
export function VehicleCreateForm({ customerId, onDone }: { customerId: number; onDone: () => void }) {
  const create = useCreateVehicle(customerId)
  const [plate, setPlate] = useState('')
  const [fields, setFields] = useState<VehicleFieldValues>(EMPTY_VEHICLE_FIELDS)

  function submit(event: FormEvent): void {
    event.preventDefault()
    if (!plate.trim()) return
    create.mutate(
      { customerId, plate: plate.trim(), ...vehicleFieldsToBody(fields), client_uuid: newUuid() },
      { onSuccess: onDone },
    )
  }

  const error = create.error instanceof ApiError ? create.error.message : null

  return (
    <form className="wf-vehicleform" onSubmit={submit}>
      <label className="wf-field">
        <span className="wf-label">Kennzeichen</span>
        <input
          className="wf-input"
          value={plate}
          autoCapitalize="characters"
          onChange={(event) => setPlate(event.target.value.toUpperCase())}
          placeholder="B-AB 123"
        />
      </label>
      <VehicleDetailFields value={fields} onChange={(patch) => setFields((f) => ({ ...f, ...patch }))} />
      {error ? (
        <p className="error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="wf-listfoot">
        <button type="button" className="wf-btn wf-btn--ghost" onClick={onDone}>
          Abbrechen
        </button>
        <button type="submit" className="wf-btn wf-btn--primary" disabled={create.isPending || !plate.trim()}>
          Fahrzeug anlegen
        </button>
      </div>
    </form>
  )
}
